import { connect } from 'react-redux';
import SdkEventStepCard from '../components/SdkEventStepCard';
import { getSdkEventStepCard } from '../selectors';
import { changeSdkEventSelection } from '../actions';

const mapStateToProps = state => getSdkEventStepCard(state);

const mapDispatchToProps = dispatch => ({
    onChange: eventNames => dispatch(changeSdkEventSelection(eventNames)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(SdkEventStepCard);


